module.exports = "/images/logo-auerswald.svg?4b72e7c37db70cfd0a4fda856654bdea";